class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('.cart-drawer__overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    const handleCartClick = (event) => {
      if (!customElements.get('cart-drawer')) return;
      event.preventDefault();
      this.open(cartLink);
    };

    cartLink.addEventListener('click', handleCartClick);
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');

    // Remove is-empty from cart-drawer element itself
    this.classList.remove('is-empty');

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('.cart-drawer__overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Fix: Wait until cart-drawer is fully defined before binding cart icon
customElements.whenDefined('cart-drawer').then(() => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) cartDrawer.setHeaderCartIconAccessibility();
});

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Gift wrap banner button handler
document.addEventListener('click', function(e) {
  if (!e.target.matches('.gift-wrap-banner__btn')) return;

  const btn = e.target;
  const variantId = btn.dataset.variantId;
  const inCart = btn.dataset.inCart === 'true';

  btn.disabled = true;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      updates: { [variantId]: inCart ? 0 : 1 },
      sections: 'cart-drawer,cart-icon-bubble'
    })
  })
  .then(r => r.json())
  .then(state => {
    const cartDrawer = document.querySelector('cart-drawer');

    // If on cart page, just reload — sections will re-render server-side
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    // Re-render drawer
    const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (drawerInner && state.sections['cart-drawer']) {
      const parsed = new DOMParser()
        .parseFromString(state.sections['cart-drawer'], 'text/html');
      const newInner = parsed.querySelector('.drawer__inner');
      if (newInner) drawerInner.innerHTML = newInner.innerHTML;
    }

    const cartBubble = document.getElementById('cart-icon-bubble');
    if (cartBubble && state.sections['cart-icon-bubble']) {
      cartBubble.innerHTML = new DOMParser()
        .parseFromString(state.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section').innerHTML;
    }

    if (cartDrawer) cartDrawer.classList.remove('is-empty');
  })

  .catch(() => { btn.disabled = false; });
});
